var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.966,
    height: 56.966,
    viewBox: "0 0 56.966 56.966",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.a{stroke:#4c4c4e;stroke-linecap:round;stroke-linejoin:round;}.b{fill:#4c4c4e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.41 4.41)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M36.759,5l4.41,2.646C41.17,13.38,35,18.231,35,18.231l-4.41-5.292c4.19,0,6.175-7.939,6.175-7.939H24.41s1.985,7.939,6.175,7.939l-4.41,5.292S20,13.38,20,7.646L24.41,5",
    transform: "translate(-6.769 -5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M40.227,8l7.057,2.646A46.945,46.945,0,0,0,42.873,23L41.85,27.009a24.963,24.963,0,0,0,.318,13.5l2.47,8.071s-4.746,4.41-15,4.41-15-4.41-15-4.41l2.47-8.071a24.963,24.963,0,0,0,.318-13.5L16.41,23A46.944,46.944,0,0,0,12,10.646L19.057,8",
    transform: "translate(-5.825 -5.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M47,23.349l5.292,24.7h5.292S55.38,15.41,51.41,11",
    transform: "translate(-9.953 -5.708)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.585,23.349l-5.292,24.7H5S7.205,15.41,11.175,11",
    transform: "translate(-5 -5.708)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 4.41,
    transform: "translate(42.34 38.811)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 4.41,
    transform: "translate(0.882 38.811)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.706,
    cy: 0.706,
    r: 0.706,
    transform: "translate(23.11 14.201)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.706,
    cy: 0.706,
    r: 0.706,
    transform: "translate(23.11 19.494)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.706,
    cy: 0.706,
    r: 0.706,
    transform: "translate(23.11 24.786)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.706,
    cy: 0.706,
    r: 0.706,
    transform: "translate(23.11 30.079)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.706,
    cy: 0.706,
    r: 0.706,
    transform: "translate(23.11 35.371)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 0.706,
    cy: 0.706,
    r: 0.706,
    transform: "translate(23.11 40.664)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 56.966,
    height: 56.966
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlouse);
export default __webpack_public_path__ + "static/media/Blouse.325377257510810d21ccb46cab889fa1.svg";
export { ForwardRef as ReactComponent };